import { configureStore } from "@reduxjs/toolkit";

import authReducer from "./auth/authSlice";
import adminReducer from "./admin/adminSlice";
import usersReducer from "./users/usersSlice";
import companyReducer from "./company/companySlice";

const store = configureStore({
  reducer: {
    auth: authReducer,
    admin: adminReducer,
    user: usersReducer,
    company: companyReducer,
  },
});

export default store;
